import React from 'react';
import PropTypes from 'prop-types';
import { Carousel } from 'react-bootstrap';
import Amenity from '../Amenity';
import styles from './styles.scss';

const propTypes = {
  amenities: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
  })),
};

const defaultProps = {
  amenities: [],
};

const FacilityAmenitiesCarousel = ({ amenities }) => {
  const carouselItems = (
    amenities.map(amenity => (
      <Carousel.Item key={amenity.name}>
        <div className={styles.mobileAmenity}>
          <Amenity {...amenity} />
        </div>
      </Carousel.Item>
    ))
  );

  const carouselProps = {
    controls: amenities.length > 1,
    indicators: false,
  };

  return (
    amenities.length === 1 ? (
      carouselItems
    ) : (
      <Carousel {...carouselProps}>
        {carouselItems}
      </Carousel>
    )
  );
};

FacilityAmenitiesCarousel.propTypes = propTypes;
FacilityAmenitiesCarousel.defaultProps = defaultProps;

export default FacilityAmenitiesCarousel;
